import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full h-screen flex bg-[#F1F0EE] font-sans" }
const _hoisted_2 = { class: "hidden md:flex h-[calc(100%-2px)] m-0" }
const _hoisted_3 = { class: "w-full h-full flex flex-col" }

import MainSidebar from "@/components/Sidebar/MainSidebar.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'MainLayout',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(MainSidebar)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})